export const changeOrderStatusOptions = [
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'DELEGATED', label: 'Delegated' },
];
